import { Tooltip } from "antd";
import i18n, { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";

interface PreliminaryIconProps extends WithTranslation {}

export const PreliminaryIcon = withTranslation(I18N_NS.PROJECT)(({ t }: PreliminaryIconProps) => {
  return (
    <Tooltip title={t("Preliminary answer")}>
      <span className="preliminary-icon">{i18n.language === "de" ? "V" : "P"}</span>
    </Tooltip>
  );
});
